import Vue from 'vue';
import GraphMixin from '@/helpers/vue_mixins/v2/GraphMixin';
import SalesGraph from '@/plugins/graphql/queries/v2/sales-graph.gql';
export default Vue.extend({
    mixins: [GraphMixin],
    apollo: {
        salesGraph: {
            query: SalesGraph,
            variables() {
                return {
                    appUuid: this.appUuid,
                };
            },
            update(data) {
                return data.salesAmountChartData;
            },
        },
    },
    props: {
        appUuid: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            salesGraph: null,
        };
    },
    computed: {
        labels() {
            const self = this;
            const data = this.salesGraph;
            return self.buildLabels(data);
        },
        graphData() {
            const self = this;
            const data = this.salesGraph;
            return self.buildGraphData(data);
        },
    },
    render() {
        if (this.$scopedSlots.default) {
            return this.$scopedSlots.default({
                salesGraph: this.salesGraph,
                labels: this.labels,
                graphData: this.graphData,
            });
        }
    },
});
